import { render } from "./Minus.vue?vue&type=template&id=dbb41242&ts=true"
import script from "./Minus.vue?vue&type=script&lang=ts"
export * from "./Minus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__